import axios from 'axios';
import { clsx } from 'clsx';
import dayjs from 'dayjs';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const isDefaultChatbot = (chatbotId, defaultChatbots) => {
  return defaultChatbots.some((chatbot) => chatbot.id === chatbotId);
};

export function getUrlFromString(str) {
  if (isValidUrl(str)) return str;
  try {
    if (str.includes('.') && !str.includes(' ')) {
      return new URL(`https://${str}`).toString();
    }
  } catch (_e) {
    return null;
  }
}

export function isValidUrl(url) {
  try {
    new URL(url);
    return true;
  } catch (_e) {
    return false;
  }
}

export function formatDateUK(timestamp) {
  return dayjs(timestamp).format('DD/MM/YYYY HH:mm:ss');
}

export function formatDateUS(dateString) {
  return dayjs(dateString).format('MMMM D, YYYY');
}

export function customFormatDate(inputDate) {
  const parts = inputDate.split(' ');
  const datePart = parts[0];
  // const timePart = parts[1];

  const dateParts = datePart.split('/');
  const day = dateParts[0];
  const month = dateParts[1];
  const year = dateParts[2];

  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const formattedMonth = monthNames[month - 1];

  const currentYear = new Date().getFullYear();
  const showYear = currentYear !== year;

  let formattedDate = `${day} ${formattedMonth}`;
  if (showYear) {
    formattedDate += ` ${year}`;
  }

  return formattedDate;
}

export const wait = (amount = 0) =>
  new Promise((resolve) => setTimeout(resolve, amount));

export function shortenId(id) {
  const prefix = 'doc_';

  if (id && typeof id === 'string') {
    const parts = id.split('-');
    return parts.length > 0 ? `${prefix}${parts[0]}` : `${prefix}${id}`;
  }
  return `${prefix}${id}`;
}

export function sanitizeName(str) {
  let sanitized = str;
  if (sanitized.length > 50) {
    sanitized = str.slice(0, 50);
  }

  if (sanitized.endsWith('.pdf')) {
    sanitized = sanitized.slice(0, -4);
  }

  return sanitized
    .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '')
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .trim() // Trim whitespace
    .replace(/\s+/g, '_')
    .slice(0, 80);
}

export function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
  );
}

export const cleanMessages = (messages, conversationId) => {
  return messages
    ?.filter((message) => message.conversationId === conversationId)
    .map((message) => ({
      value: message.value,
      context: message.type,
    }));
};

export const getDisplayName = (user, type) => {
  if (type === 'embeddings') {
    return 'Anara';
  }

  if (type === 'chatGPT') {
    return 'ChatGPT';
  }

  if (type === 'user') {
    if (!user) {
      return 'Guest';
    }

    if (user.displayName) {
      return user.displayName;
    }

    return user.email.split('@')[0];
  }
};

export const stringToArray = (str) => {
  const arr = str.split('\n');
  return arr.map((item) => item.replace(/^\d+\.\s*/, ''));
};

export const getCountryByIP = async () => {
  try {
    const response = await axios.get('https://ipinfo.io');
    const country = response.data.country;
    // console.log('response.data', response.data);
    // console.log('Country:', country);
    return country;
  } catch (error) {
    console.error('Error fetching IP information:', error);
  }
};

export const isHelpMenuChat = (id) => {
  return [
    '1c55de72-a9bb-4953-979f-9b0af4af0722',
    'b9f91d6f-39c1-469b-a482-fe877e59f5df',
    '4eea99b2-655c-4d6f-a574-7479a3261e14',
  ].includes(id);
};
